// extracted by mini-css-extract-plugin
export var adjacentSlide = "_n2-9";
export var arrowButtonContainer = "_n2-5";
export var arrowButtonIcon = "_n2-6";
export var carouselArrowButton = "_n2-2";
export var carouselElementContainer = "_n2-1";
export var currentSlide = "_n2-8";
export var left = "_n2-3";
export var otherSlide = "_n2-a";
export var productCarouselContainer = "_n2-0";
export var right = "_n2-4";
export var sliderOverflow = "_n2-7";